// extracted by mini-css-extract-plugin
export default {"fieldsetLegend":"FieldsetGroup_fieldsetLegend__0FKER"};